import {
  AUTOBUILDER_TAB_DEFAULT,
  DESKTOP_LOCG_AUTOBUILDER
} from '@app/analytics/src/constants/optimizely'
import { AccordionLOCGenerator } from '@app/code/src/components/LoggedOutCodeGeneratorV2/AccordionLOCGenerator'
import { AutobuilderLOCGenerator } from './AutobuilderLOCGenerator'
import { Container } from '@dtx-company/design-system/src'
import { FC, useEffect } from 'react'
import { ScrollableLOCGenerator } from '@app/code/src/components/LoggedOutCodeGeneratorV2/ScrollableLOCGenerator'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { selectSection } from '../../machines/locg/locgSelectors'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'

export const LoggedOutCodeGenerator: FC = () => {
  const [autobuilderVersion] = useFlowFeature(DESKTOP_LOCG_AUTOBUILDER)
  const [showAutoBuilderFirst] = useFlowFeature(AUTOBUILDER_TAB_DEFAULT)
  const { locgService } = useGlobalServices()
  const currentSection = useSelector(locgService, selectSection)
  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_Section_View', { value: currentSection })
  }, [currentSection])
  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_Desktop_LOCG_autobuilder', {
      value: autobuilderVersion,
      showAutoBuilderFirst
    })
  }, [autobuilderVersion, showAutoBuilderFirst])

  // 2 Containers and display none/block are used to avoid initial rendering of desktop component on mobile.
  // isMobile and a single Container can't be used (see mobile screen size)
  return (
    <>
      <Container
        maxWidth="xl"
        disableGutters
        sx={{ display: { xs: 'none', md: 'block' }, visibility: { xs: 'hidden', md: 'visible' } }}
      >
        {!autobuilderVersion && <AccordionLOCGenerator />}
        {autobuilderVersion && <AutobuilderLOCGenerator />}
      </Container>
      <Container
        maxWidth="lg"
        disableGutters
        sx={{ display: { xs: 'block', md: 'none' }, visibility: { xs: 'visible', md: 'hidden' } }}
      >
        <ScrollableLOCGenerator />
      </Container>
    </>
  )
}
